import React, { PureComponent } from 'react'
import { bool, node, oneOf, string, number } from 'prop-types'

import Field, {
  FieldQuestion,
  FieldAnswer,
  FieldRequired,
  FieldAssistance,
  FieldFeedback
} from '../../Field'
import VisuallyHidden from '../../VisuallyHidden'

class TextFieldTemplate extends PureComponent {
  render () {
    const {
      assistance,
      children,
      controlName,
      feedback,
      hideLabel,
      inverse,
      label,
      required,
      wordLimit,
      value,
      type,
      status
    } = this.props

    let feedbackStr = feedback

    const TextFieldTemplateQuestion = () => (
      <FieldQuestion htmlFor={controlName} /* matches Control controlName */>
        {label && <span dangerouslySetInnerHTML={{ __html: label }} />}
        {required && <FieldRequired />}
        {/* matches Control required attribute */}
      </FieldQuestion>
    )

    if (!feedbackStr && type === 'textarea' && wordLimit > 0) {
      feedbackStr = `${value === '' ? 0 : value.trim().split(' ').length} / ${wordLimit} Words`
    }

    return (
      <Field id={`field--${controlName}`} status={status} template="text">
        {hideLabel ? (
          <VisuallyHidden>
            <TextFieldTemplateQuestion />
          </VisuallyHidden>
        ) : (
          <TextFieldTemplateQuestion />
        )}
        <FieldAnswer>{children}</FieldAnswer>
        {feedbackStr && (
          <FieldFeedback inverse={inverse}>{feedbackStr}</FieldFeedback>
        )}
        {assistance && <FieldAssistance>{assistance}</FieldAssistance>}
      </Field>
    )
  }
}

TextFieldTemplate.propTypes = {
  assistance: node,
  controlName: string,
  type: string,
  value: string,
  children: node.isRequired,
  feedback: node,
  hideLabel: bool,
  wordLimit: number,
  inverse: bool,
  label: node.isRequired,
  required: bool,
  status: oneOf([ 'error', 'notice', 'success', 'warning' ])
}

export default TextFieldTemplate
